import {
  CollectionContext,
  DialogContext,
  UserInfoContext,
  WindowContext,
} from "GlobalContext";
import {
  Dialog,
  Loading,
  ModalCancelButton,
  ModalDeleteButton,
  NoteBookList,
} from "components";
import React, { useContext, useEffect, useState } from "react";
import { ScrollView, StyleSheet, Text, View } from "react-native";
import {
  DeleteNoteBooks,
  FetchNoteBookDeleteTargets,
} from "server/collectionConnect";
import { formWrap, modalFormStyles } from "styles";
import { NoteBookDeleteListType, WikiDeleteModalStatus } from "types";
type Props = {
  hideModal: Function;
  modalStatus: WikiDeleteModalStatus;
};

export function NoteBookDeleteForm({ hideModal, modalStatus }: Props) {
  const { userInfo } = useContext(UserInfoContext);
  const { windowWidth } = useContext(WindowContext);
  const { setAlert } = useContext(DialogContext);
  const { NoteBookCollection } = useContext(CollectionContext);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [noteBooks, setNoteBooks] = useState<NoteBookDeleteListType[]>(
    defaultData()
  );

  useEffect(() => {
    if (modalStatus === null) {
      setNoteBooks(defaultData());
      return;
    }
    const result = FetchNoteBookDeleteTargets(
      NoteBookCollection,
      modalStatus.ids
    );
    if (result === null) {
      setNoteBooks(defaultData());
      return;
    }
    setNoteBooks(result);
  }, [modalStatus]);

  const deleteNoteBook = async (): Promise<void> => {
    if (modalStatus === null) return;

    setIsLoading(true);
    try {
      const result = await DeleteNoteBooks(
        userInfo,
        modalStatus.ids,
        NoteBookCollection
      );
      if (result.isCheck) {
        setAlert({
          isAlert: true,
          msg: result.message,
          confTxt: "OK",
          afterExec: () => {
            hideModal();
          },
        });
      } else {
        setAlert({ isAlert: true, msg: result.message });
      }
    } catch {
      setAlert({ isAlert: true, msg: "削除に失敗しました" });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <View style={modalFormStyles.container}>
        <Text style={styles.headingText}>削除するブック</Text>
        <Loading isLoading={isLoading} />

        <ScrollView
          showsVerticalScrollIndicator={false}
          style={modalFormStyles.scrollContainer}
        >
          <View style={[formWrap(windowWidth).formWrap]}>
            <Text style={styles.footerText}>
              ノートブックを削除した場合、そのノートブック内に存在するページも同時に削除されます。
            </Text>
            <NoteBookList noteBooksData={noteBooks} />
            <View style={modalFormStyles.formItem}>
              <ModalCancelButton
                buttonText="キャンセル"
                onClick={() => hideModal()}
              />

              <ModalDeleteButton
                buttonText="削除"
                onClick={() => deleteNoteBook()}
                widths="40%"
              />
            </View>
          </View>
        </ScrollView>
      </View>
      <Dialog />
    </>
  );
}

/** Wikiページ削除一覧の初期値を登録します */
const defaultData = (): NoteBookDeleteListType[] => {
  return [
    {
      id: "",
      bookName: "",
      updateAt: null,
    },
  ];
};

const styles = StyleSheet.create({
  container: {
    flex: 3,
    backgroundColor: "#fff",
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
    marginTop: 30,
  },
  headingText: {
    fontSize: 32,
  },
  formWrap: {
    marginTop: "10%",
  },
  formItem: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  footerText: {
    alignSelf: "center",
    textAlign: "center",
    fontSize: 15,
    lineHeight: 30,
    color: "red",
  },
});
